const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'こんにちは',
    'Ref: Page content body': '出発と到着時に、QRコードのスキャンを忘れないでください',
  },
};
export default labels;
